<template>
  <div class="vrap">
    <a class="fileBlock" :href="fileInfo.link" download>
      <div class="pictIcon">{{rash}}</div>
      <div class="fileName  ml-3">{{ fileInfo.name }}</div>
    </a>
  </div>
</template>

<script>
export default {
  name: "FileMessage",
  props:['fileInfo'],
  setup(props) {
    let rash = props.fileInfo.name.split('.');
    rash = '.'+rash.slice(-1);
    return {
      rash
    }
  }
}
</script>

<style scoped>
.fileBlock {
  display: inline-flex;
  padding: 1em;
  border: solid 1px;
  border-color: var(--c-primary-200);
  border-radius: 6px;
  text-decoration: none!important;
  align-items: center;
    flex-wrap: wrap;
    width: 100%;
}
.fileName{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
.pictIcon {
  background: url("data:image/svg+xml;base64,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");
  width: 50px;
  height: 54px;
  color: #fff;
  padding: 22px 0px 0px 8px;
  text-align: center;
}
.vrap {
  padding-top: 0.625rem;
}
</style>